export interface CommissionSlab {
  id: string;
  range: string;
  percentage: string;
}

export interface PrincipalBank {
  id: string;
  principalBankId?: number; // For existing banks from API
  name: string;
  accountHolderName: string;
  accountNo: string;
  ifscCode: string;
  bankCity: string;
}

export interface PrincipalFormData {
  // Basic Information
  name: string;
  principalCode: string;
  shortName: string;
  logoUrl: File | null; // Only File object, no URL
  merchantId: string;
  
  // Commission Information
  commissionType: string;
  commissionPercentage: string;
  commissionFixedAmount: string;
  commissionSlabs: CommissionSlab[];
  
  // Voucher & Location
  voucherType: string;
  country: string;
  isDistributionOnly: boolean;
  
  // Payment & Contract
  paymentTerm: string;
  contractDocumentUrl: File | null; // Only File object, no URL
  
  // Additional Settings
  principalConversionRate: string;
  useLogo: boolean;
  redemptionNotification: boolean;
  redemptionDetails: string;
  codeValidityBalanceCheck: boolean;
  codeActivationFeeAmount: string;
  codeActivationFeeCurrency: string;
  
  // Bank Details (Multiple) - matches principalBanks from API
  principalBanks: PrincipalBank[];
  
  // Contact Information (matching distributor profile fields)
  contactInformation: {
    email: string;
    phone: string;
    contactPerson: string;
    address: {
      city: string;
      state: string;
      street: string;
      country: string;
      zipCode: string;
    };
  };
  
  // Whitelisted IPs
  whiteListedIps: string[];
  
  // Account Information (for user creation)
  email: string;
  password: string;

  // Optional self distributor mapping
  addSelfDistributor: boolean;
  distributorId: string;
}

export interface PrincipalFormErrors {
  name: string;
  principalCode: string;
  shortName: string;
  merchantId: string;
  logoUrl: string;
  contractDocumentUrl: string;
  commissionPercentage: string;
  commissionFixedAmount: string;
  voucherType: string;
  country: string;
  commissionType: string;
  paymentTerm: string;
  redemptionDetails?: string;
  principalConversionRate: string;
  codeActivationFeeAmount: string;
  codeActivationFeeCurrency: string;
  principalBanks: string;
  contactInformation: {
    email: string;
    phone: string;
    contactPerson: string;
    address: {
      street: string;
      city: string;
      state: string;
      country: string;
      zipCode: string;
    };
  };
  whiteListedIps: string;
  email: string;
  password: string;
  commissionSlabs: string;
  distributorId?: string;
}

export const initialFormData: PrincipalFormData = {
  name: "",
  principalCode: "",
  shortName: "",
  logoUrl: null,
  merchantId: "",
  commissionType: "percentage",
  commissionPercentage: "",
  commissionFixedAmount: "0.00",
  commissionSlabs: [],
  voucherType: "erupi",
  country: "IND",
  isDistributionOnly: false,
  paymentTerm: "",
  contractDocumentUrl: null,
  principalConversionRate: "1.0000",
  useLogo: false,
  redemptionNotification: false,
  redemptionDetails: "",
  codeValidityBalanceCheck: false,
  codeActivationFeeAmount: "0.00",
  codeActivationFeeCurrency: "",
  principalBanks: [],
  contactInformation: {
    email: "",
    phone: "",
    contactPerson: "",
    address: {
      city: "",
      state: "",
      street: "",
      country: "",
      zipCode: "",
    },
  },
  whiteListedIps: [],
  email: "",
  password: "",
  addSelfDistributor: false,
  distributorId: "",
};

export const initialFormErrors: PrincipalFormErrors = {
  name: "",
  principalCode: "",
  shortName: "",
  merchantId: "",
  logoUrl: "",
  contractDocumentUrl: "",
  commissionPercentage: "",
  commissionFixedAmount: "",
  voucherType: "",
  country: "",
  commissionType: "",
  paymentTerm: "",
  redemptionDetails: "",
  principalConversionRate: "",
  codeActivationFeeAmount: "",
  codeActivationFeeCurrency: "",
  principalBanks: "",
  contactInformation: {
    email: "",
    phone: "",
    contactPerson: "",
    address: {
      street: "",
      city: "",
      state: "",
      country: "",
      zipCode: "",
    },
  },
  whiteListedIps: "",
  email: "",
  password: "",
  commissionSlabs: "",
  distributorId: "",
};

